import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { getShop, UpdateEstimationAnswer, getShopUsers } from '../../../actions/shops'
import { getCustomerGroupAgreements } from '../../../actions/customerGroup'
import { loginAs } from '../../../actions/auth'

// Components
import Phone from './../../../shared/components/Phone'

// Elements
import Row from './../../../shared/elements/row'
import Col from './../../../shared/elements/col'
import Panel from './../../../shared/elements/panel'
import Text from './../../../shared/elements/text'
import Switch from './../../../shared/elements/switch'
import Radio from './../../../shared/elements/radio'
import Button from './../../../shared/elements/button'
import LabelWrapper from './../../../shared/elements/labelWrapper'
import Label from './../../../shared/elements/label'

// Styles
import './view.scss'

// Utils
import { translation } from '../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      shop: {
        Active: true,
        Address: '',
        Alias: '',
        CVR: '',
        ChainId: this.props.auth.user.ChainId,
        City: '',
        CompanyName: '',
        Email: '',
        Partners: [],
        // PermissionModules: [],
        PhoneCode: this.props.phonecode,
        PhoneNumber: '',
        ShopId: 0,
        ShopType: 0,
        TakseringType: 0,
        UserId: 0,
        UserName: '',
        ZipCode: '',
        SubscriptionType: 0,
        EstimationAnswer: 0
      },
      CustomerGroupAgreements: [],
      ShopOwners: [],
      Employees: []
    }
    this.renderCustomerGroups = this.renderCustomerGroups.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.UpdateEstimationAnswer = this.UpdateEstimationAnswer.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentDidMount () {
    this.getShopInfoes(this.props)
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps (nextProps) {
    this.getShopInfoes(nextProps)
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  getShopInfoes (props) {
    if (typeof props.item.ShopId !== 'undefined') {
      props.getShop(props.item.ShopId).then((res) => {
        this.setState({
          shop: res.data
        })
      })
      props.getCustomerGroupAgreements(props.item.ShopId).then((res) => {
        this.setState({
          CustomerGroupAgreements: res.data
        })
      })
      props.getShopUsers(props.item.ShopId).then((res) => {
        this.setState({
          ShopOwners: res.data.ShopOwners,
          Employees: res.data.Employees
        })
      })
    } else {
      this.resetCreate()
    }
  }

  loginAs (id) {
    this.props.loginAs(id).then((res) => {
      this.props.router.push(res.data.StartScreen)
    })
  }

  UpdateEstimationAnswer (e) {
    let data = {
      ShopId: this.props.item.ShopId,
      EstimationAnswer: this.state.shop.EstimationAnswer
    }
    this.props.UpdateEstimationAnswer(data).then((res) => {
      this.setState({
        shop: res.data
      })
    })
  }

  onRadioChange (e) {
    let value = e.target.value
    this.setState({
      shop: {
        ...this.state.shop,
        EstimationAnswer: value
      }
    }, this.UpdateEstimationAnswer)
  }

  renderShop () {
    let shop = this.state.shop
    const ActiveChecked = (type, active) => {
      if (active === type) {
        return (
          true
        )
      }
    }
    return (
      <Panel title={translation('14709')}>
        <Text name='CompanyName' value={shop.CompanyName || ''} disabled labelText={translation('30')} />
        <Text name='Alias' value={shop.Alias || ''} disabled labelText={translation('1863')} />
        <Text name='Address' value={shop.Address || ''} disabled labelText={translation('25')} />
        <Text name='ZipCode' value={shop.ZipCode || ''} disabled labelText={translation('40')} />
        <Text name='City' value={shop.City || ''} disabled labelText={translation('37')} />
        <Text name='CVR' value={shop.CVR || ''} disabled labelText={translation('41')} />
        <LabelWrapper labelText={translation('38')}>
          <Phone
            onChange={this.onPhoneChange}
            onBlur={this.onPhoneBlur}
            code={shop.PhoneCode || ''}
            number={shop.PhoneNumber || ''}
            disabled />
        </LabelWrapper>
        <Text name='Email' value={shop.Email || ''} disabled labelText={translation('1052')} />
        <Text name='UserName' value={shop.UserName || ''} disabled labelText={translation('1')} />

        <Switch name='Active' value='true' checked={ActiveChecked(true, shop.Active) || false} disabled labelText={translation('295')} />
      </Panel>
    )
  }

  renderSettings () {
    return (
      <Panel title={translation('6')}>
        <LabelWrapper labelText={translation('14711')}>
          <Radio id='WP_Estimation' name='SubscriptionType' value='0' checked={this.state.shop.EstimationAnswer + '' === '0'} onChange={this.onRadioChange} labelText={translation('14712')} />
          <Radio id='Both_Estimation' name='SubscriptionType' value='1' checked={this.state.shop.EstimationAnswer + '' === '1'} onChange={this.onRadioChange} labelText={translation('736')} />
          <Radio id='UL_Estimation' name='SubscriptionType' value='2' checked={this.state.shop.EstimationAnswer + '' === '2'} onChange={this.onRadioChange} labelText={translation('14713')} />
        </LabelWrapper>
      </Panel>
    )
  }

  renderCustomerGroups () {
    const CustomerGroup = (val) => {
      return (
        <LabelWrapper labelText={val.CustomerGroupName}>
          {val.AgreementNames.map((val) => { return <Label className='name'>{val}</Label> })}
        </LabelWrapper>
      )
    }

    return (
      <Panel title={translation('14710')}>
        {this.state.CustomerGroupAgreements.map(CustomerGroup)}
      </Panel>
    )
  }

  renderUsers (Title, Users) {
    const User = (val, key) => {
      if (!(val.Id > 0)) {
        return
      }
      console.log('user', val)
      return (
        <LabelWrapper labelText={val.Name} key={key}>
          <Button style='link' onClick={this.loginAs.bind(this, val.Id)} labelText={translation('57')} />
        </LabelWrapper>
      )
    }

    return (
      <Panel title={Title}>
        {Users.map(User)}
      </Panel>
    )
  }

  render () {
    if (this.state.dimensions !== undefined && this.state.dimensions.width > 950 && this.state.dimensions.width < 1500) {
      return (
        <Row>
          <Col>
            {this.renderShop()}
            {this.renderSettings()}
            {this.renderCustomerGroups()}
          </Col>
          <Col>
            {this.renderUsers(translation('1860'), this.state.ShopOwners)}
            {this.renderUsers(translation('10'), this.state.Employees)}
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col>
            {this.renderShop()}
          </Col>
          <Col>
            {this.renderSettings()}
          </Col>
          <Col>
            {this.renderCustomerGroups()}
          </Col>
          <Col>
            {this.renderUsers(translation('1860'), this.state.ShopOwners)}
            {this.renderUsers(translation('10'), this.state.Employees)}
          </Col>
        </Row>
      )
    }
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes
  }
}

export default connect(mapStateToProps, {
  getShop,
  getCustomerGroupAgreements,
  UpdateEstimationAnswer,
  getShopUsers,
  loginAs
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Subcontractors/View/index.js